export const ChatRoles = Object.freeze({
  Agent: 1,
  User: 2,
  Bot: 3,
 
  1: "Agent",
  2: "User",
  3: "Bot",
 
});